import {tracking_events} from '@utilities/track-abstract/track-abstract';

// Linkedin tracking

// Lead: 	„Beim Händler anfragen“ (Produktverfügbarkeit) als Lead tracken	FB, LN

let tracking_started = false;

const sal_linkedin = {
    start_tracking: () => {
        if (tracking_started) { return; }
        else { tracking_started = true; }

        /* eslint-disable */
        if (!window._linkedin_partner_id) {
            return;
        }

        window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
        window._linkedin_data_partner_ids.push(window._linkedin_partner_id);
        (function () {
            var s = document.getElementsByTagName("script")[0];
            var b = document.createElement("script");
            b.type = "text/javascript";
            b.async = true;
            b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
            s.parentNode.insertBefore(b, s);
        })();
        /* eslint-enable */
        // Page view:		FB, LN
    },
    // eslint-disable-next-line no-unused-vars
    track_event: (event, payload) => {
        switch (event) {
        // Add to cart	<img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=3535297&conversionId=4160612&fmt=gif" />
        // Lead	<img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=3535297&conversionId=4160620&fmt=gif" />
        // Complete registration	<img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=3535297&conversionId=4160628&fmt=gif" />
        // Contact	<img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=3535297&conversionId=4160636&fmt=gif" />
        // Moodboard	<img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=3535297&conversionId=4160644&fmt=gif" />
        case tracking_events.ClickEmail: // payload = email
        case tracking_events.ClickPhone: // payload = number
            new Image(1,1).src = 'https://px.ads.linkedin.com/collect/?pid=3535297&conversionId=4160636&fmt=gif';
            break;
            // Klick auf Ask a Distributor
        case tracking_events.AddToDealerRequest:
            new Image(1,1).src = 'https://px.ads.linkedin.com/collect/?pid=3535297&conversionId=4160620&fmt=gif';
            break;
        case tracking_events.AddToCart:
            new Image(1,1).src = 'https://px.ads.linkedin.com/collect/?pid=3535297&conversionId=4160612&fmt=gif';
            break;
        case tracking_events.ClickLogin:
        case tracking_events.ClickRegister:
            new Image(1,1).src = 'https://px.ads.linkedin.com/collect/?pid=3535297&conversionId=4160628&fmt=gif';
            break;
        case tracking_events.UrlContainsMoodboard:
            new Image(1,1).src = 'https://px.ads.linkedin.com/collect/?pid=3535297&conversionId=4160644&fmt=gif';
            break;
        }
    }
};

export { sal_linkedin };
